// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n[dir] .customer-analytics[data-v-51ccfbd0] {\n  padding: 20px;\n}\n[dir] .card[data-v-51ccfbd0] {\n  margin-bottom: 20px;\n}\n", ""]);
// Exports
module.exports = exports;
